export interface ICredentialObject {
  credential: string | null;
  token: string | null;
  onLogin?: (token: string) => void;
}